import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LaureateView from '../views/LaureateView.vue'
import ForbiddenView from "@/views/ForbiddenView.vue";
import axios from "axios";
import ApiHelper from "@/helpers/apiHelper.ts";
import PolicyView from "@/views/PolicyView.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/laureat/:laureate',
      name: 'laureate',
      component: LaureateView,
    },
    {
      path: '/polityka-prywatnosci',
      name: 'polityka',
      component: PolicyView
    },
    {
      path: '/forbidden',
      name: 'forbidden',
      component: ForbiddenView
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'home' }
    }
  ],
});

// **Interceptor requestów – sprawdza IP przed KAŻDYM zapytaniem**
const axiosInstance = axios.create();
axios.interceptors.request.use( async (config) => {
  try {
    const response = await axiosInstance.get(ApiHelper.checkIp());
    if (response.status === 200 && response.data.status === "allowed") {
      return config;
    } else {
      throw new Error("IP blocked");
    }
  } catch (error) {
    if (router.currentRoute.value.path !== '/forbidden') {
      router.push('/forbidden');
    }

    return Promise.reject(error);
  }
});
export default router
